import {ruleRunner} from 'utils/validation/ruleRunner'
import {required} from 'utils/validation/rules'

export const reCaptchaValidator = ruleRunner('captchaToken', 'captchaToken', required)
